import React from "react";
import styled from "styled-components";

const Head = styled.h2`
  color: black;
  font-size: 40px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: 1em;
  background-color: hsl(0, 0%, 100%);
  height: 5vh;
  animation-name: slide-right;
  animation-duration: 4s;

  @media only screen and (max-width: 760px) {
    font-size: 22px;
  }
`;

const Heading = ({ prop }) => {
  return <Head>{prop}</Head>;
};

export default Heading;
